import React from 'react';
import {connect} from 'react-redux';
import copy from 'copy-to-clipboard';
// Components
import Dialog from "@material-ui/core/Dialog";
import Header from 'Components/common/Header';
import BasicButton from 'Components/common/BasicButton';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import LoadingIcon from 'Components/icons/LoadingIcon';

// Actions
import {getInternalOrderDetail, updateInternalOrderStatus} from 'Actions/host';
import {openNotification} from 'Actions/notification';
import {T} from 'Actions/translate';

import { USER_ROLE, INTERNAL_ORDER_TYPE } from 'Utils/constant'

function DetailCard(props) {
    // type: 0 out section, 1 in section, 2 product list
    const {internalOrderDetail, type} = props;
    if (!internalOrderDetail) return null;
    if (!Object.keys(internalOrderDetail).length) return null;
    // eslint-disable-next-line eqeqeq
    if (type == 0) {
        return (
            <ul className="detail-card callout">
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">{T('supplyCenter')}</span>
                    <span className="card-item-value">
                        {internalOrderDetail.fromScName}
                    </span>
                </li>
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">{T('oerder_number')}</span>
                    <span className="card-item-value">
                        {internalOrderDetail.orderNumber}
                    </span>
                </li>
            </ul>
        );
        // eslint-disable-next-line eqeqeq
    } else if (type == 1) {
        return (
            <ul className="detail-card callin">
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">{T('supplyCenter')}</span>
                    <span className="card-item-value">
                        {internalOrderDetail.toScName}
                    </span>
                </li>
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">{T('consignee')}</span>
                    <span className="card-item-value">
                        {internalOrderDetail.receiver}
                    </span>
                </li>
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">{T('telephone')}</span>
                    <span className="card-item-value">
                        {internalOrderDetail.receiverTel}
                    </span>
                </li>
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">
                        {T('shippingAddress')}
                    </span>
                    <span className="card-item-value">
                        {internalOrderDetail.receiverAddress}
                    </span>
                </li>
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">
                        {T('order_delivery_method')}
                    </span>
                    <span className="card-item-value">
                        {T(`internal_order_expressway_${internalOrderDetail.expressType && internalOrderDetail.expressType.trim().toLowerCase()}`)}
                    </span>
                </li>
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">
                        {T('shippment_details_shipment_number')}
                    </span>
                    <span className="card-item-value">
                        {internalOrderDetail.expressNumber}
                    </span>
                </li>
                <li className="detail-card-item flex-column">
                    <span className="card-item-name flex-column-item">
                        {T('shippment_remark')}
                    </span>
                    <span className="card-item-value flex-column-item fixed-box">
                        {internalOrderDetail.remark}
                    </span>
                </li>
            </ul>
        );
    } else {
        const products = internalOrderDetail.internalOrderProductModels;
        if (!products || !products.length) return null;
        return products.map((product) => (
            <ul className="detail-card product" key={product.id}>
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">{T('product_sku')}</span>
                    <span className="card-item-value">{product.itemDisplay}</span>
                </li>
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">
                        {T('shipment_sku_lot')}
                    </span>
                    <span className="card-item-value">{product.lot}</span>
                </li>
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">
                        {T('host_abnormal_amount')}
                    </span>
                    <span className="card-item-value">{product.quantity}</span>
                </li>
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">
                        {T('storeCondition')}
                    </span>
                    <span className="card-item-value">
                        {product.storeCondition}
                    </span>
                </li>
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">
                        {T('fone_order_shipping_condition')}
                    </span>
                    <span className="card-item-value">
                        {product.shippingCondition}
                    </span>
                </li>
                <li className="detail-card-item flex-row">
                    <span className="card-item-name">
                        {T('specifications')}
                    </span>
                    <span className="card-item-value">
                        {product.specifications}
                    </span>
                </li>
            </ul>
        ));
    }
}
class InternalTransferOrderDetail extends React.Component {
    state = {
        confirmationDialogVisible: false
    }
    componentDidMount() {
        this.props.getInternalOrderDetail({
            orderId: this.props.match.params.id,
        });
    }
    componentDidUpdate(prevProps) {
        console.log('[InternalTransferOrderdetail] componentDidUpdate, prevProps.internalOrderStatus', prevProps.internalOrderStatus)
        const showTip = prevProps.internalOrderStatus === 'UPDATING'
        showTip && this.handleTip()
    }
    openConfirmationDialog = () => {
        this.setState({confirmationDialogVisible: true})
    }
    closeConfirmationDialog = () => {
        this.setState({confirmationDialogVisible: false})
    }
    /**
     * @func 判断显示哪个action，撤回|收货|null
     * 1. 撤回显示条件: 订单状态为'SHIPPED'且用户角色为ADMIN|HOST且为调出订单
     * 2. 收货显示条件:订单状态为'SHIPPED'且用户角色为HOST且为调入订单
     * @return object 
     * {type: 'RECEIVE|REVERT', btn_label: '收货|撤回', confirm_title:'', confirm_msg:''}
     */
    getAction = () => {
        const { internalOrderDetail, history, localData } = this.props
        const { orderType } = history.location.state
        let action = null
        if (internalOrderDetail && internalOrderDetail.status === 'SHIPPED') {
            // eslint-disable-next-line eqeqeq
            if (orderType == INTERNAL_ORDER_TYPE.OUT){
                // eslint-disable-next-line eqeqeq
                if (localData.roleType == USER_ROLE.ADMIN || localData.roleType == USER_ROLE.HOST) {
                    action = {
                        type: 'REVERT',
                        btn_label: T('host_internal_withdrawal'),
                        confirm_title: T('transferPackage'),
                        confirm_msg: T('confirmTransferPackage')
                    }
                }
            } else {
                // eslint-disable-next-line eqeqeq
                if (localData.roleType == USER_ROLE.HOST) {
                    action = {
                        type: 'RECEIVE',
                        btn_label:T('shippment_take_goods'),
                        confirm_title: T('host_full_receive'),
                        confirm_msg: T('host_full_ReceiveConfirm')
                    }
                }
            }
        }
        return action
    }
    updateShipStatus = (action) => {
        const {internalOrderStatus} = this.props;
        if (internalOrderStatus === 'UPDATING') {
            this.props.openNotification(T(`${action.type.toLowerCase}_repeat_tip`), 'danger');
            return
        }
        this.closeConfirmationDialog()
        const param = {orderId: this.props.match.params.id}
        if (action.type === 'RECEIVE') {
            param.actionType='RECEIVE'
        } else if(action.type === 'REVERT') {
            param.actionType='REVERT'
        }
        this.props.updateInternalOrderStatus(param)
    };
    handleTip = () => {
        const {internalOrderDetail, internalOrderStatus} = this.props;
        if (!internalOrderDetail || internalOrderDetail.status !== 'SHIPPED') return
        let tipMsg = ''
        switch (internalOrderStatus) {
            case 'RECEIVED':
                tipMsg = `${T('transferSuccess')}${internalOrderDetail.orderNumber}`
                this.props.openNotification(tipMsg, 'success');
                break;
            case 'REVERTED':
                tipMsg = `${T('withdrawSuccess')}${internalOrderDetail.orderNumber}`
                this.props.openNotification(tipMsg, 'success');
                break;
            case 'RECEIVE_FAILED':
                tipMsg =T('transferFail')
                this.props.openNotification(tipMsg, 'danger');
                break;
            case 'REVERT_FAILED':
                tipMsg = T('withdrawFail');
                this.props.openNotification(tipMsg, 'danger');
                break;
            default:
                break;
        }
    };
    copyToClipBoard = () => {
        const {
            receiverAddress,
            receiver,
            receiverTel,
        } = this.props.internalOrderDetail;
        copy(`${receiverAddress} ${receiver} (${receiverTel})`);
        this.props.openNotification(T('notification_copy_success'), 'success');
    };
    goBack = () => {
        if(this.props.history.location.state && (this.props.history.location.state.orderType==0 || this.props.history.location.state.orderType==1)){
			let orderType = this.props.history.location.state.orderType
			this.props.history.push('/internalTransferOrderList',{orderType})
		}else{
			this.props.history.push('/internalTransferOrderList')
		}
    }

    render() {
        const { internalOrderDetail, internalOrderStatus } = this.props;
        const { confirmationDialogVisible } = this.state
        const action = this.getAction()
        let pageBody = null, fixedBar = null;
        if (!internalOrderDetail) {
            pageBody = <LoadingIcon className="circle-animation" />;
        } else if (Object.keys(internalOrderDetail).length) {
            const showFixedBar = action &&
                (internalOrderStatus !== 'RECEIVED' && internalOrderStatus !== 'REVERTED');
            fixedBar = showFixedBar ? (
                <section className="container-max-width is-fixed fixed-bottom-bar">
                    <BasicButton
                        type="primary"
                        className="btn-action"
                        onClickOfSingleTap={this.openConfirmationDialog}
                        isStopPropagation={true}>
                        {action.btn_label}
                    </BasicButton>
                </section>
            ) : null;
            pageBody = (
                <ScrollWrapper showAbyss={true}>
                    <div className="internal-order-detail">
                        <section>
                            <div className="detail-card-title">
                                <h3>{T('host_internal_callout_order')}</h3>
                            </div>
                            <DetailCard
                                internalOrderDetail={internalOrderDetail}
                                type={0}></DetailCard>
                        </section>
                        <section className="internal-order-detail-card">
                            <div className="detail-card-title">
                                <h3>{T('host_internal_callin_order')}</h3>
                                <BasicButton
                                    className="copy-red"
                                    onClickOfSingleTap={this.copyToClipBoard}
                                    isStopPropagation={true}>
                                    {T('copyall_btn_label')}
                                </BasicButton>
                            </div>
                            <DetailCard
                                internalOrderDetail={internalOrderDetail}
                                type={1}></DetailCard>
                        </section>
                        <section>
                            <DetailCard
                                internalOrderDetail={internalOrderDetail}
                                type={2}></DetailCard>
                        </section>
                    </div>
                </ScrollWrapper>
            );
        }
        return (
            <>
            <div className={ fixedBar ? "internal-order-detail-container margin-bottom": "internal-order-detail-container"}>
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <div className="F1-order-list-header">
                        <h3 className="header-title">
                            {T('internal_transfer_order_detail')}
                        </h3>
                    </div>
                </Header>
                {pageBody}
                {fixedBar}
            </div>
            <Dialog
                open={confirmationDialogVisible}
                fullWidth={true}
                >
                <div className="confirm-popup">
                <div className="confirm-popup-title">{action && action.confirm_title}</div>
                <div className="confirm-popup-body">{action && action.confirm_msg}</div>
                <div className='confirm-popup-actions'>
                    <BasicButton className='confirm-action-btn confirm-ok-btn' onClickOfSingleTap={() => {
                        this.updateShipStatus(action)
                    }}>
                        <span>{T('btn_action_ok')}</span>
                    </BasicButton>
                    <BasicButton className='confirm-action-btn confirm-cancel-btn' onClickOfSingleTap={this.closeConfirmationDialog}>
                        <span>{T('btn_action_cancel')}</span>
                    </BasicButton>
                </div>
                </div>
            </Dialog>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData, host} = state
    const {internalOrderDetail, internalOrderStatus} = host;
    return {internalOrderDetail, internalOrderStatus, localData};
};

const mapDispatchToProps = {
    getInternalOrderDetail,
    updateInternalOrderStatus,
    openNotification,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(InternalTransferOrderDetail);
